import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { HeroSection } from '@frontend/containers/HeroSection';
import { useCoinPriceContext } from '@frontend/providers/CoinPriceProvider';
import { useWalletConfig } from '@frontend/providers/WalletConfigProvider';
import { useWalletInfo, WalletInfoProvider } from '@frontend/providers/WalletInfoProvider';
import { useWeb3React } from '@web3-react/core';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useCallback, useMemo } from 'react';
var WalletAndFarm = dynamic(function () {
  return import('@frontend/containers/WalletAndFarm');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@frontend/containers/WalletAndFarm')];
    },
    modules: ["../containers/ContentPage/index.tsx -> " + '@frontend/containers/WalletAndFarm']
  }
});
var AutoRefresh = dynamic(function () {
  return import('@frontend/components/AutoRefresh');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@frontend/components/AutoRefresh')];
    },
    modules: ["../containers/ContentPage/index.tsx -> " + '@frontend/components/AutoRefresh']
  }
});

var ContentInside = function ContentInside() {
  var router = useRouter();

  var _useWalletConfig = useWalletConfig(),
      profiles = _useWalletConfig.profiles,
      proActivated = _useWalletConfig.proActivated;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var _useCoinPriceContext = useCoinPriceContext(),
      coinPriceRefetch = _useCoinPriceContext.refetch;

  var _useWalletInfo = useWalletInfo(),
      loading = _useWalletInfo.loading,
      refetchWallets = _useWalletInfo.refetchWallets;

  var handleRefetch = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return coinPriceRefetch();

          case 2:
            _context.next = 4;
            return refetchWallets([]);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [coinPriceRefetch, refetchWallets]);
  var showWalletAndFarm = useMemo(function () {
    var _router$query;

    var isHaveProfiles = profiles.flatMap(function (_ref2) {
      var wallets = _ref2.wallets;
      return wallets;
    }).length !== 0;
    var isHaveAccount = !!account;
    var isHaveWatchAccount = !!(router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.wallet);
    return isHaveProfiles || isHaveAccount || isHaveWatchAccount;
  }, [profiles, account, router === null || router === void 0 ? void 0 : router.query]);
  return _jsxs(_Fragment, {
    children: [proActivated && _jsx(AutoRefresh, {
      onRefetch: handleRefetch,
      loading: loading
    }), _jsx(HeroSection, {
      showWorth: showWalletAndFarm
    }), showWalletAndFarm && _jsx(WalletAndFarm, {})]
  });
};

var ContentPage = function ContentPage() {
  return _jsx(WalletInfoProvider, {
    children: _jsx(ContentInside, {})
  });
};

export default ContentPage;